import { palette } from '../global/palette';
import { inputLabelClasses } from '@mui/material';
import type { ComponentOverride } from '../types';

export const MuiInputLabel: ComponentOverride<'MuiInputLabel'> = {
  MuiInputLabel: {
    styleOverrides: {
      root: {
        lineHeight: 1,
        color: palette.grey[600],
        transform: `translate(16px, 16px) scale(1)`,
        [`&.${inputLabelClasses.shrink}`]: {
          transform: `translate(14px, -7px) scale(0.8)`,
        },
        [`&.${inputLabelClasses.focused}`]: {
          color: palette.primary.main,
        },
        [`&.${inputLabelClasses.error}`]: {
          color: palette.error.main,
        },
      },
      sizeSmall: {
        transform: `translate(16px, 12px) scale(1)`,
        [`&.${inputLabelClasses.shrink}`]: {
          transform: `translate(14px, -7px) scale(0.8)`,
        },
      },
    },
  },
};
